"use strict";
/// TODO: IMPLEMENT COMMENTS
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * Component to render a single comment
 *
 * Proptypes
 * @param {string} _id of comment
 * @param {string} creator RETRIEVED FROM USER STATE IN DATABASE
 * @param {string} creator_userId
 * @param {string} content of the comment
 */
// TODO: add type but is this dead code?
const SingleComment = (props) => {
    return (react_1.default.createElement("div", { className: "Card-commentBody" },
        react_1.default.createElement("strong", null,
            props.creator || "Unknown",
            ":"),
        react_1.default.createElement("span", null, " " + props.content)));
};
exports.default = SingleComment;
